export * from './variants/Tabs';
